// extracted by mini-css-extract-plugin
export var disabled = "_o-5";
export var error = "_o-1";
export var fitContent = "_o-6";
export var hasSuffix = "_o-4";
export var iconWrapper = "_o-b";
export var infoIconWrapper = "_o-d _o-b";
export var input = "_o-a";
export var inputWrapper = "_o-0";
export var large = "_o-8";
export var leadingIconWrapper = "_o-c _o-b";
export var measureBox = "_o-e";
export var medium = "_o-7";
export var readonly = "_o-2";
export var small = "_o-3";
export var suffix = "_o-9";